import { Routes } from '@angular/router';
import { canDeactivateFormFn } from '@core/guards';
import { clusterResolver } from './resolvers/cluster.resolver';

export const routes: Routes = [
	{
		path: '',
		data: { breadcrumb: 'CLUSTER_LIST.BREADCRUMBS.MAIN' },
		children: [
			{
				path: '',
				loadComponent: () =>
					import('./components/cluster-list/cluster-list.component').then(
						(component) => component.ClusterListComponent
					)
			},
			{
				path: 'add',
				data: { breadcrumb: 'CLUSTER_EDITION.BREADCRUMBS.ADD' },
				loadComponent: () =>
					import('./components/cluster-edition/cluster-edition.component').then(
						(component) => component.ClusterEditionComponent
					)
			},
			{
				path: ':clusterId',
				canDeactivate: [
					(component, currentRoute, currentState, nextState) =>
						canDeactivateFormFn(component.form, {
							componentRef: component,
							nextState
						})
				],
				data: {
					breadcrumb: (route: any) => {
						const cluster = route.data?.value;
						return cluster?.name || 'CLUSTER_EDITION.TITLES.EDIT';
					}
				},
				resolve: { value: clusterResolver },
				loadComponent: () =>
					import('./components/cluster-edition/cluster-edition.component').then(
						(component) => component.ClusterEditionComponent
					)
			}
		]
	}
];
